import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaClock, FaCalendarAlt } from 'react-icons/fa';
import './Services.css';

const CourtRental = () => {
  const pricing = [
    {
      type: 'Peak Hours',
      time: '6:00 PM - 10:00 PM (Weekdays)',
      price: '$25',
      per: '/hour',
      features: ['Professional court', 'LED lighting', 'Climate controlled', 'Equipment rental available']
    },
    {
      type: 'Off-Peak Hours',
      time: '6:00 AM - 6:00 PM (Weekdays)',
      price: '$18',
      per: '/hour',
      features: ['Professional court', 'LED lighting', 'Climate controlled', 'Equipment rental available']
    },
    {
      type: 'Weekends',
      time: 'All Day Saturday & Sunday',
      price: '$22',
      per: '/hour',
      features: ['Professional court', 'LED lighting', 'Climate controlled', 'Equipment rental available']
    }
  ];

  const schedule = [
    { day: 'Monday - Friday', hours: '6:00 AM - 10:00 PM' },
    { day: 'Saturday', hours: '7:00 AM - 10:00 PM' },
    { day: 'Sunday', hours: '7:00 AM - 8:00 PM' },
    { day: 'Public Holidays', hours: '8:00 AM - 6:00 PM' }
  ];

  return (
    <div className="court-rental-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Court Rental</span>
            <h1>Book a Court</h1>
            <p>Professional badminton courts available for hourly rental</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <Link to="/services">Services</Link>
              <span>/</span>
              <span>Court Rental</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Court Features */}
      <section className="section">
        <div className="container">
          <div className="about-main-grid">
            <div className="about-main-content">
              <span className="section-badge">Premium Facilities</span>
              <h2>World-Class Courts for Every Player</h2>
              <p>
                Net Nest Badminton Sports Club offers premium indoor badminton court rental services for players, groups, and organizations looking for a professional and well-maintained playing environment. Our courts are designed to meet high-quality playing standards, making them ideal for casual play, practice sessions, training matches, and small tournaments.
              </p>
              <div className="about-features">
                <div className="feature-item">
                  <FaCheckCircle />
                  <span>BWF-Approved Flooring</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle />
                  <span>Professional LED Lighting</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle />
                  <span>Climate Controlled</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle />
                  <span>Online Booking System</span>
                </div>
              </div>
            </div>
            <div className="about-main-images">
              <img src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600" alt="Badminton Court" className="main-image" />
            </div>
          </div>
          <div className="about-main-grid">
            <div className="about-main-content">
              <h2>Flexible Court Booking Options</h2>
              <p>
                We offer flexible court rental options to suit different needs and schedules. Players can book courts on an hourly basis or for extended sessions. Whether you want a quick practice game, a regular weekly booking, or a longer training session, our court rental service is designed to accommodate your requirements with ease.
              </p>
            </div>
            <div className="about-main-images">
              <h2>Suitable for All Players</h2>
              <p>
                Our court rental service is open to:
                <br></br>
                Individual players
                <br></br>
                Doubles teams
                <br></br>
                Groups of friends
                <br></br>
                Corporate teams
                <br></br>
                Schools and colleges
                <br></br>
                Both recreational and competitive players can enjoy a professional playing atmosphere without enrolling in coaching programs.
              </p>
            </div>
          </div>
          <div className="about-main-grid">
            <div className="about-main-content">
              <h2>Ideal for Practice & Friendly Matches</h2>
              <p>
                The court rental facility is perfect for independent practice, friendly matches, and preparation for upcoming tournaments. Players can experience match-like conditions, helping improve performance, coordination, and confidence on the court.
              </p>
            </div>
            <div className="about-main-images">
              <h2>Clean, Safe & Well-Maintained Environment</h2>
              <p>
                At Net Nest Badminton Sports Club, hygiene and safety are a priority. Our courts are regularly cleaned and maintained to ensure optimal playing conditions. A well-organized environment allows players to focus fully on their game.
              </p>
            </div>
          </div>
          <div className="about-main-grid">
            <div className="about-main-content">
              <h2>Additional Facilities</h2>
              <p>
                Comfortable seating areas
                <br></br>
                Changing rooms and washrooms
                <br></br>
                Drinking water facility
                <br></br>
                First-aid support
              </p>
            </div>
            <div className="about-main-images">
              <h2>Easy Booking & Support</h2>
              <p>
                Our booking process is simple and user-friendly. Players can reserve courts in advance to avoid waiting and ensure availability. Our staff is always available to assist with scheduling and any specific requirements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Play?</h2>
            <p>Book your court now and experience the best badminton facilities</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-white">Book a Court</Link>
              <Link to="/membership" className="btn btn-outline-white">View Membership</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CourtRental;
